import { HNSRMYY_QUESTIONNAIRE_URL, HNSRMYY_ORGANIZATION_UID, DRY_EYE_CLINIC_CN_NAME } from '@/utils/constant'

export default {
  name: 'Department',
  data () {
    return {
      department: '',
      source:'',
      address: '',
      orgUid: '',
      isShowQrCode: false,
      isShowQuestionnaire: false
    }
  },
  methods:{
    initPage() {
      this.department = this.$route.query.department;
      this.address = this.$route.query.address;
    },
    goBack() {
      this.$router.push({path: this.source});
    },
    goQuestionnaire() {
      // 河南省立眼科医院的调查问卷
      window.location.href = HNSRMYY_QUESTIONNAIRE_URL;
    }
  },
  mounted: function () {
    this.source = this.$route.query.source;
    this.orgUid = this.$route.params.orgUid;
    // 为河南省立眼科医院时，显示公众号二维码
    this.isShowQrCode = this.orgUid === HNSRMYY_ORGANIZATION_UID
    this.initPage();
    // 当为河南省立眼科医院且当前科室为“干眼门诊”时，显示调查问卷
    this.isShowQuestionnaire = this.orgUid === HNSRMYY_ORGANIZATION_UID && this.department === DRY_EYE_CLINIC_CN_NAME
  }
}



// WEBPACK FOOTER //
// ./src/views/mixins/guide/DepartmentMixin.js